<template>
  <div class="loading_container"
    v-if="visible">
    <div class="mask"></div>
    <div class="loading_inner">
      <van-loading size="24px" vertical>{{alertText || '加载中...'}}</van-loading>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ILoading',
  props: {
    visible: Boolean,
    alertText: String
  }
};
</script>

<style scoped lang="stylus">
.loading_container {
  position fixed
  left 0
  right 0
  top 0
  bottom 0
  z-index: 10;
  .mask {
    position absolute
    left 0
    right 0
    top 0
    bottom 0
    background-color rgba(0, 0, 0, .7)
  }
  .loading_inner {
    position absolute
    left 0
    right 0
    top 50%
    transform translate(0, -50%)
  }
}
</style>
